"use client";
import { j as o } from "../../node_modules/react/jsx-runtime.js";
import { useEffect as g } from "react";
import { TextHolderBuilderV2 as m } from "../shared/_mm_modules.js";
import { isHexaColor as s, useIsInView as k, hasProperty as x, getItemBgColor as b, getItemTextColor as C, getItemTextAlignment as p } from "@ddg-frontend/fe-essentials";
import { usePropsContext as B } from "../../context/provider.js";
const f = () => {
  var n, a;
  const { configs: t, content: e } = B(), l = t.blockBackgroundImage ? {
    backgroundImage: `url("${t.blockBackgroundImage}")`,
    backgroundColor: t.blockBackgroundColor
  } : s(t.blockBackgroundColor) ? { backgroundColor: t.blockBackgroundColor } : void 0, i = (n = e.data[0]) == null ? void 0 : n.texts, c = (a = e.data[0]) == null ? void 0 : a.hyperlinks, [d, r] = k({
    rootMargin: "0px",
    threshold: 0.5,
    triggerOnce: !0
  }), u = t.extraClasses.includes("animated");
  return g(() => {
    x("BrandLib", window) && window.BrandLib.refresh();
  }, [r]), /* @__PURE__ */ o.jsx(
    "article",
    {
      "data-react-block": !0,
      className: `block-just-text ${t.textAreaAlignment} ${t.extraClasses} ${t.blockLine} ${t.blockMargin} ${!s(t.blockBackgroundColor) && " " + t.blockBackgroundColor} ${r && u ? "animate" : ""}`,
      ref: d,
      style: l,
      ...t.attributes && t.attributes,
      children: /* @__PURE__ */ o.jsx("div", { className: "part", children: /* @__PURE__ */ o.jsx(
        m,
        {
          backgroundColor: b(0, t.itemBackgroundColor),
          textColor: C(t.itemTextColor, 0),
          textAlignment: p(0, t.itemTextAlignment),
          texts: i,
          textsOrder: ["title", "subTitle", "additionalText", "description"],
          hyperlinks: c
        }
      ) })
    }
  );
}, w = f;
export {
  w as default
};
